<template>
  <!-- eslint-disable -->
  <div class="message-item">
    <div class="message-item__settings-wrapper">
      <div class="d-flex align-center">
        <v-checkbox
          class="message-item__settings--human mr-4"
          :label="'Human'"
          v-model="node.human"
          color="primary"
          hide-details="auto"
          @change="isHumanChanged">
        </v-checkbox>
        <v-text-field
          class="message-item__settings--delay panzoom-ignore"
          v-model="node.delay"
          :label="'Delay'"
          persistent-placeholder
          :placeholder="'2000'"
          :disabled="node.human"></v-text-field>
      </div>
    </div>

    <v-btn v-if="!showEditor" class="d-flex" text outlined @click="showEditor = true"> Content Edit </v-btn>

    <div v-if="!showEditor">
      <div class="content-preview-label">Content preview</div>
      <div>
        <div class="text-left content-preview" v-html="node.content"></div>
      </div>
    </div>

    <va-tinymce-input
      v-if="showEditor"
      ref="tinymce"
      class="mb-4 w-full"
      :current-content="node.content"
      :editor-height="120"
      live-chat-message-preset
      title="Message"
      :forced-root-block-attrs="{ class: 'live-chat-message' }"
      auto-resize
      @update="content => updateMessageContent(content)" />

    <VaColorPicker
      class="mb-4 panzoom-ignore"
      :title="'Background color'"
      hide-alpha-slider
      v-model="node.backgroundColor"></VaColorPicker>
    <div class="checkbox-grid">
      <v-checkbox
        class="panzoom-ignore"
        :label="'Hide background'"
        v-model="node.hideBackground"
        color="primary"
        hide-details="auto">
      </v-checkbox>
      <v-checkbox
        class="panzoom-ignore"
        :label="'Full-width'"
        v-model="node.fullWidth"
        color="primary"
        hide-details="auto">
      </v-checkbox>
      <v-checkbox
        class="panzoom-ignore"
        :label="'Hide loader'"
        v-model="node.hideLoader"
        color="primary"
        hide-details="auto">
      </v-checkbox>
    </div>
    <v-text-field
      class="message-item__settings--cssclass panzoom-ignore"
      v-model="node.cssClass"
      :label="'Class'"
      persistent-placeholder
      :placeholder="''"></v-text-field>
    <v-checkbox
      v-if="$can('view', 'live chat ringba parameters')"
      class="mb-3"
      :label="'Ringba replace script'"
      v-model="node.hasRingbaScript"
      color="primary"
      hide-details="auto"
      @change="hasRingbaScriptChange">
    </v-checkbox>

    <code-input
      v-if="node.hasRingbaScript"
      class="panzoom-ignore ringba-script-input mb-3"
      v-model="node.ringbaScript"
      :title="'Ringba script'"></code-input>

    <VaAudioFileInput
      v-if="!node.human"
      :label="'Audio file'"
      :file-id="fileId"
      @update:file="updateAudioFile"
      :file-name="fileName"
      :file-url="fileUrl"></VaAudioFileInput>
  </div>
</template>

<script>
  import CodeInput from "@/components/custom/CodeInput";
  import VaColorPicker from "@/components/custom/VaColorPicker";
  import VaAudioFileInput from "@/components/custom/VaAudioFileInput";
  import { AUDIO_FILE } from "./constant";

  /* eslint-disable */
  export default {
    name: "LiveChatMessage",
    components: { CodeInput, VaColorPicker, VaAudioFileInput },
    props: {
      node: {
        type: Object,
        required: true,
      },
      isLastMessage: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        showEditor: !this.node?.content,
      };
    },
    computed: {
      fileId() {
        return this.node?.audio?.fileID || "";
      },
      fileName() {
        return this.node?.audio?.fileName || "";
      },
      fileUrl() {
        return this.node?.audio?.fileURL || "";
      },
    },
    methods: {
      updateContent(content) {
        if (this.$refs.tinymce) {
          this.$refs.tinymce.updateContent(content);
        }
      },
      updateAudioFile(fileData) {
        if (fileData) {
          // Set "audio" property as reactive, so that audio input works with live chat websites that were created
          // when "audio" property did not exist on live chat messages and action items
          this.$set(this.node, "audio", {});
          this.node.audio.fileID = fileData["@id"];
          this.node.audio.fileURL = fileData.contentUrl;
          this.node.audio.fileName = fileData.fileName;
        } else {
          this.node.audio = { ...AUDIO_FILE };
        }
      },
      isHumanChanged(val) {
        if (!val) {
          this.node.audio = { ...AUDIO_FILE };
        }
      },
      hasRingbaScriptChange(val) {
        if (!val) {
          this.node.ringbaScript = "";
        }
      },
      updateMessageContent(content) {
        this.node.content = content;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .ringba-script-input {
    text-align: left;
  }

  .checkbox-grid {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 12px;

    .v-input {
      flex: 0 0 50%;
      margin-bottom: 6px;
    }
  }
</style>
